module.exports = __webpack_public_path__ + "media/images/products/market-desktop-2beb6685ad39a1bd5c3d223cb2e9b314.png";